import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon, ShieldCheckIcon, CreditCardIcon, ZapIcon, ClockIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function PricingCard() {
  return <section id="pricing" className="py-10 sm:py-14 px-4 relative scroll-mt-10" data-id="element-186">
      <div className="absolute inset-0 bg-brand-orange/10 blur-[150px] rounded-full max-w-3xl mx-auto" data-id="element-187" />

      <div className="max-w-md sm:max-w-lg mx-auto relative z-10" data-id="element-188">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-3xl sm:text-4xl font-black text-center mb-6 text-brand-cream" data-id="element-189">
          Das "Swiss Peak System" Angebot
        </motion.h2>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-gradient-to-b from-[#1a0f0a] to-[#120a06] border border-brand-orange/40 rounded-3xl relative shadow-[0_0_50px_rgba(220,38,38,0.15)] mb-8" data-id="element-190">
          {/* Badge */}
          <div className="flex justify-center -mt-4 mb-2" data-id="element-191">
            <div className="bg-gradient-to-b from-brand-gold to-gray-300 text-black font-black px-5 py-1.5 rounded-full flex items-center gap-1.5 uppercase tracking-wide text-xs shadow-[0_0_20px_rgba(245,245,245,0.5)]" data-id="element-192">
              <StarIcon className="w-3.5 h-3.5 fill-current" data-id="element-193" />
              DIE BELIEBTESTE WAHL
            </div>
          </div>

          <div className="p-6 sm:p-8" data-id="element-194">
            <h3 className="text-base sm:text-lg font-black text-center text-brand-cream uppercase mb-6 leading-tight" data-id="element-195">
              GESAMTWERT DES INHALTS:
            </h3>

            <div className="space-y-0 mb-5" data-id="element-196">
              {[{
              label: '3 Master-Bände (Tomo 1, 2, 3)',
              price: '97 CHF'
            }, {
              label: 'SBB-Kalender & GPS-Kompass',
              price: '57 CHF'
            }, {
              label: 'Alpine Identity Training',
              price: '47 CHF'
            }, {
              label: '3 Exklusive Bonus-Guides',
              price: '49 CHF'
            }].map((item, i) => <div key={i} className="flex justify-between items-center border-b border-white/10 py-3 gap-3" data-id="element-197">
                  <span className="text-gray-300 font-medium text-xs sm:text-sm" data-id="element-198">
                    {item.label}
                  </span>
                  <span className="text-gray-500 line-through text-sm shrink-0" data-id="element-199">
                    {item.price}
                  </span>
                </div>)}
              <div className="flex justify-between items-center pt-4" data-id="element-200">
                <span className="text-sm sm:text-base font-black text-brand-cream uppercase" data-id="element-201">
                  GESAMTWERT:
                </span>
                <span className="text-xl sm:text-2xl font-black text-brand-danger line-through" data-id="element-202">
                  250 CHF
                </span>
              </div>
            </div>

            {/* Discount badge */}
            <div className="flex justify-center mb-4" data-id="element-203">
              <div className="bg-brand-danger/20 border border-brand-danger/40 text-brand-danger font-black px-4 py-1.5 rounded-full text-xs uppercase tracking-wide" data-id="element-204">
                92% RABATT HEUTE
              </div>
            </div>

            {/* Inner offer card */}
            <div className="bg-[#1f110a] border border-brand-orange/40 rounded-2xl p-5 text-center mb-5" data-id="element-205">
              <div className="flex justify-center items-center gap-2 mb-2" data-id="element-206">
                <span className="text-4xl sm:text-5xl font-black text-brand-cream" data-id="element-207">
                  47.90 CHF
                </span>
              </div>
              <p className="text-xs text-gray-300 mt-2 font-medium" data-id="element-208">
                💳 Einmalzahlung • ⚡ Sofortiger Zugriff
              </p>
            </div>

            {/* Salirà presto pill */}
            <div className="flex justify-center mb-5" data-id="element-209">
              <div className="inline-flex items-center gap-2 border border-brand-orange/40 bg-brand-orange/5 px-4 py-1.5 rounded-full" data-id="element-210">
                <ClockIcon className="w-4 h-4 text-brand-orange" data-id="element-211" />
                <span className="text-xs font-bold text-brand-orange" data-id="element-212">
                  Einführungspreis — steigt bald auf 97 CHF
                </span>
              </div>
            </div>

            <CTAButton href="https://suiza.kitonline.shop/cart/44708314710151:1" className="w-full mb-5" data-id="element-213">
              JA! ICH WILL DAS KOMPLETTE KIT
            </CTAButton>
          </div>
        </motion.div>

        {/* UPGRADE CARD */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-gradient-to-b from-[#1a0f0a] to-[#120a06] border border-brand-orange/40 rounded-3xl relative shadow-[0_0_50px_rgba(220,38,38,0.15)]" data-id="element-214">
          {/* Badge */}
          <div className="flex justify-center -mt-4 mb-2" data-id="element-215">
            <div className="bg-gradient-to-b from-brand-orange to-red-600 text-white font-black px-5 py-1.5 rounded-full flex items-center gap-1.5 uppercase tracking-wide text-xs shadow-[0_0_20px_rgba(220,38,38,0.5)]" data-id="element-216">
              <StarIcon className="w-3.5 h-3.5 fill-current" data-id="element-217" />
              JETZT UPGRADEN UND ALLES MITNEHMEN
            </div>
          </div>
          <div className="flex justify-center mb-2" data-id="element-218">
            <div className="text-brand-gold font-black uppercase tracking-wide text-xs" data-id="element-219">
              ⭐ SEHR EMPFOHLEN
            </div>
          </div>

          <div className="p-6 sm:p-8" data-id="element-220">
            <h3 className="text-xl sm:text-2xl font-black text-center text-brand-cream uppercase mb-2 leading-tight" data-id="element-221">
              Swiss Peak INSIDER PRO 🏔️
            </h3>
            <div className="flex justify-center items-center gap-2 mb-6" data-id="element-222">
              <span className="text-brand-orange font-black text-xl" data-id="element-223">
                + 10.00 CHF
              </span>
              <span className="text-gray-500 line-through text-sm" data-id="element-224">
                + 60.00 CHF
              </span>
            </div>

            <p className="text-sm text-gray-300 font-medium mb-4 text-center" data-id="element-225">
              Das komplette Pro-Upgrade — alles aus dem Starter-Paket PLUS:
            </p>

            <div className="space-y-3 mb-6" data-id="element-226">
              {['10 "Unsichtbare" Stationen — Die Orte ohne Website, nur mit Telefonnummer. Pässe ab 25 CHF.', 'Komplettes Familien-System — Ausrüstungs-Rotations-System für Kinder. Skifahren für quasi 0 CHF.', 'Gruppen-Organisations-Protokoll — Für 6 bis 20 Personen. Firmenausflüge professionell geplant.', 'SAC-Hütten & Airbnb Insider — Übernachten in den Alpen ab 48 CHF Vollpension.'].map((item, i) => <div key={i} className="flex items-start gap-2" data-id="element-227">
                  <span className="text-green-500 font-bold shrink-0" data-id="element-228">✅</span>
                  <span className="text-gray-300 text-sm font-medium" data-id="element-229">
                    {item}
                  </span>
                </div>)}
            </div>

            <div className="bg-[#1f110a] border border-brand-orange/40 rounded-2xl p-4 text-center mb-5" data-id="element-230">
              <p className="text-sm font-bold text-brand-cream mb-1" data-id="element-231">
                Gesamtpaket Swiss Peak INSIDER PRO:
              </p>
              <div className="text-3xl font-black text-brand-cream mb-1" data-id="element-232">
                57.90 CHF
              </div>
              <p className="text-xs text-gray-400" data-id="element-233">
                (statt 47.90 CHF + 60 CHF Einzelwert des Upgrades)
              </p>
            </div>

            <CTAButton href="https://suiza.kitonline.shop/cart/44708316479623:1" className="w-full mb-5" data-id="element-234">
              JETZT KAUFEN
            </CTAButton>

            <div className="flex flex-wrap justify-center items-center gap-x-3 gap-y-1 text-[11px] sm:text-xs text-gray-400 font-medium" data-id="element-235">
              <span className="flex items-center gap-1" data-id="element-236">
                <ZapIcon className="w-3 h-3 text-brand-gold" data-id="element-237" /> Sofortiger
                Zugriff
              </span>
              <span className="text-gray-600" data-id="element-238">•</span>
              <span className="flex items-center gap-1" data-id="element-239">
                <CreditCardIcon className="w-3 h-3 text-brand-gold" data-id="element-240" />{' '}
                Einmalzahlung
              </span>
              <span className="text-gray-600" data-id="element-241">•</span>
              <span className="flex items-center gap-1" data-id="element-242">
                <ShieldCheckIcon className="w-3 h-3 text-brand-gold" data-id="element-243" /> 7 Tage
                Garantie
              </span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}